import React from 'react'
import css from './Copy.module.css'

const IntroCopy = ({ children }) => <div className={css.copy}>{children}</div>

export default IntroCopy
